export class StringUtils {
    public static capitalizeFirstLetter = (s: string): string => {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }
}

declare global {
    interface String {
        capitalizeFirstLetter(): string;
    }

}

String.prototype.capitalizeFirstLetter = function () {
    return StringUtils.capitalizeFirstLetter(`${this}`);
}